export enum FundToRenderRequestStatusEnum {
  PENDING_SUPERVISOR_APROVAL,
  PENDING_ADMIN_APROVAL,
  REJECTED,
  CANCELLED,
  ACCEPTED,
  COMPLETED
}